import { useMatch } from 'react-router-dom'
import Confirm from './Confirm'
import Change from './Change'

const Main = () => {
  const isConfirmMail = useMatch({ path: '/acc/confirm-mail' })
  const isChangeEmail = useMatch({ path: '/acc/change-email' })

  if (isConfirmMail) return <Confirm />
  if (isChangeEmail) return <Change />
  return null
}

export default Main
